import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { YandexAutorizationDto } from "../interfaces/yandexAutorizationDto";

export const yandexAutorization = () =>
  axiosInstance.get<YandexAutorizationDto>(LIGIN_API_URL.yandexAutorization());
